/**
 * Verifica si una lista de propiedades están definidas en el objeto
 *
 * @param  {*}      props  Props a buscar
 * @param  {*}      objeto Objeto a verificar props
 * @return {Object}        Tupla de status y props encontradas
 */
export const checkifPropertiesExist = (props, objeto) => {
    const propsArray = Array.isArray(props) ? props : [props.toString()];

    const result = {
        status: false,
        keys: []
    };

    result.keys = propsArray.map((item) => {
        result.status = Object.prototype.hasOwnProperty.call(objeto, item);

        return (result.status) ? item : null;
    }).filter((item) => item);

    return result;
};

/**
 * Verifies if object is empty or has empty attributes.
 *
 * @param  {*}      objeto Objeto a verificar props
 * @return {Boolean}
 */
export const checkifEmptyObject = (objeto) => {
    return Object.values(objeto).every(x => (x === null || x === ''));
};

export const removeDuplicates = (originalArray, keys) => {
    const filtered = originalArray.filter(
        (s => o =>
            (k => !s.has(k) && s.add(k))
            (keys.map(k => o[k]).join('|'))
        )
        (new Set())
    );
    return filtered;
}

/**
 * Convert object properties and values to string pharagraph.
 * @param {Object} obj
 */
export const objToString = obj => {
 let str = '';
 for (const p in obj) {
     if (obj.hasOwnProperty(p)) {
         str += p + ': ' + obj[p] + '\n';
     }
 }
 return str;
};

/**
 * Removes empty keys in object.
 * @param {Object} obj
 */
export const removeEmptyKeys = obj => {
    Object.keys(obj).forEach(key => {
        if (obj[key] && typeof obj[key] === 'object') removeEmptyKeys(obj[key]);
        else if (obj[key] === null || typeof obj[key] === 'undefined') delete obj[key];
    });

    return obj;
};